module.exports = __webpack_public_path__ + "img/home_jiameng.4a5339b4.png";